import { useVersionStore } from '~/stores/version'

export default defineNuxtPlugin(() => {
  if (import.meta.server) return

  const versionStore = useVersionStore()
  const router = useRouter()

  versionStore.initialize()

  // If the page is outdated, force a reload on the navigation event
  router.beforeEach((to, from, next) => {
    if (versionStore.isOutdated) {
      window.location.href = to.fullPath
      return
    }
    next()
  })
})
